export default __webpack_public_path__ + "static/media/gallery_03.a0135a60.jpg";